import { useRef, useState, useEffect } from 'react';
import {
    Input,
    Label
} from './style';

import paperclip from '../../../../Assets/Images/Careers/paperclip.svg'

const FileInput = (props) => {
    const inputRef = useRef(null)
    const [value, setValue] = useState('')

    useEffect(() => {
        if (props.reset) {
            setValue('');
            if (inputRef.current) inputRef.current.value = '';
        }
    }, [props.reset]);

    const relativePath = (value) => {
        return value.split(/[\/\\]/).pop()
    }

    const handleInput = (e) => {
        setValue(e.target.value)
    }

    return (<>
        <Label htmlFor={props.name}>
            <span className={value ? '' : 'placeholder'}>{
                value ? relativePath(value) : props.placeholder
        }</span>
        <img src={paperclip} />
        </Label>
        <Input {...props} id={props.name} ref={inputRef} type="file" onInput={handleInput} />
        </>
    );
}

export default FileInput;